import { CategoryBadge } from '@/features/categories';
import { S } from '@/shared/constants/styles';

export default function TransactionRow({
  transaction: t,
  onEdit, onDelete, onSplit, onDeleteAllSplits,
  deleteTxId, setDeleteTxId,
  incomeList, getGroup, currency,
  theme,
  compact = false,
  anomalyMap = new Map(),
}) {
  const fmtAUD = (v) => (Number(v) || 0).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const isIncome = incomeList.includes(t.category);
  const anomaly = anomalyMap.get(t.id);

  if (compact) {
    return (
      <tr style={{ borderBottom: "1px solid " + theme.cardBorder }}>
        <td style={{ padding: "10px", color: theme.textMuted, whiteSpace: "nowrap" }}>{String(t.date || "")}</td>
        <td style={{ padding: "10px", fontWeight: 500, color: theme.text }}>{String(t.description || "")}</td>
        <td style={{ padding: "10px" }}><CategoryBadge category={t.category} theme={theme} /></td>
        <td style={{ padding: "10px", fontWeight: 700, color: isIncome ? "#16a34a" : theme.text }}>{currency + fmtAUD(t.amount)}</td>
        <td style={{ padding: "10px", color: theme.textSub }}>{String(t.who || "")}</td>
        <td style={{ padding: "10px" }}>
          <button onClick={() => onEdit(t)} style={S.link("#3b82f6")}>Edit</button>
          {deleteTxId === t.id ? (
            <span style={{ marginLeft: 8 }}>
              <span style={{ fontSize: 11, color: theme.textMuted }}>Delete? </span>
              <button onClick={() => onDelete(t.id)} style={{ ...S.link("#ef4444"), fontWeight: 700 }}>Yes</button>
              <button onClick={() => setDeleteTxId(null)} style={{ ...S.link(theme.textMuted), marginLeft: 6 }}>No</button>
            </span>
          ) : (
            <button onClick={() => setDeleteTxId(t.id)} style={{ ...S.link("#ef4444"), marginLeft: 8 }}>Del</button>
          )}
        </td>
      </tr>
    );
  }

  return (
    <tr
      style={{ borderBottom: "1px solid " + theme.cardBorder, transition: "background 0.1s" }}
      onMouseOver={e => e.currentTarget.style.background = theme.tableHover}
      onMouseOut={e => e.currentTarget.style.background = "transparent"}
    >
      <td style={{ padding: "10px", color: theme.textMuted, whiteSpace: "nowrap" }}>{String(t.date || "")}</td>
      <td style={{ padding: "10px", fontWeight: 500, color: theme.text }}>
        <span>{String(t.description || "")}</span>
        {t.splitGroupId && (
          <span style={{
            marginLeft: 6, fontSize: 10, fontWeight: 700, padding: '1px 5px',
            background: 'rgba(168,85,247,0.15)', color: '#a855f7',
            border: '1px solid rgba(168,85,247,0.3)', borderRadius: 4,
          }}>split</span>
        )}
        {anomaly && (
          <span style={{
            marginLeft: 6, fontSize: 10, fontWeight: 700, padding: '1px 5px',
            background: anomaly.type === 'high-amount' ? 'rgba(239,68,68,0.15)' : 'rgba(245,158,11,0.15)',
            color: anomaly.type === 'high-amount' ? '#ef4444' : '#d97706',
            border: '1px solid ' + (anomaly.type === 'high-amount' ? 'rgba(239,68,68,0.3)' : 'rgba(245,158,11,0.3)'),
            borderRadius: 4,
          }}>
            {anomaly.type === 'high-amount' ? 'unusual' : 'new'}
          </span>
        )}
      </td>
      <td style={{ padding: "10px" }}><CategoryBadge category={t.category} theme={theme} /></td>
      <td style={{ padding: "10px", fontSize: 11, color: theme.textMuted }}>{String(getGroup(t.category))}</td>
      <td style={{ padding: "10px", fontWeight: 700, color: isIncome ? "#16a34a" : theme.text }}>{currency + fmtAUD(t.amount)}</td>
      <td style={{ padding: "10px", color: theme.textSub }}>{String(t.who || "")}</td>
      <td style={{ padding: "10px", color: theme.textMuted, fontSize: 11 }}>{String(t.paymentMethod || "")}</td>
      <td style={{ padding: "10px", color: theme.textMuted, fontSize: 11, maxWidth: 100, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{String(t.notes || "")}</td>
      <td style={{ padding: "10px" }}>
        {(t.tags || []).length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
            {(t.tags || []).map(tag => (
              <span key={tag} style={{
                background: 'rgba(99,102,241,0.15)',
                color: '#6366f1',
                border: '1px solid rgba(99,102,241,0.3)',
                borderRadius: 5, padding: '1px 6px', fontSize: 10, fontWeight: 600,
              }}>{tag}</span>
            ))}
          </div>
        )}
      </td>
      <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
        {!t.splitGroupId && onSplit && (
          <button onClick={() => onSplit(t)} style={{ ...S.link('#a855f7'), marginRight: 8 }}>Split</button>
        )}
        <button onClick={() => onEdit(t)} style={S.link("#3b82f6")}>Edit</button>
        {deleteTxId === t.id ? (
          <span style={{ marginLeft: 8 }}>
            <span style={{ fontSize: 11, color: theme.textMuted }}>Delete? </span>
            <button onClick={() => onDelete(t.id)} style={{ ...S.link("#ef4444"), fontWeight: 700 }}>Yes</button>
            {t.splitGroupId && onDeleteAllSplits && (
              <button onClick={() => onDeleteAllSplits(t.splitGroupId)} style={{ ...S.link("#ef4444"), marginLeft: 6, fontWeight: 700 }}>All splits</button>
            )}
            <button onClick={() => setDeleteTxId(null)} style={{ ...S.link(theme.textMuted), marginLeft: 6 }}>No</button>
          </span>
        ) : (
          <button onClick={() => setDeleteTxId(t.id)} style={{ ...S.link("#ef4444"), marginLeft: 8 }}>Del</button>
        )}
      </td>
    </tr>
  );
}
